module.exports = __webpack_public_path__ + "img/r3-en.924ccfc0.jpeg";